import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addcourse',
  templateUrl: './addcourse.component.html',
  styleUrls: ['./addcourse.component.css']
})
export class AddcourseComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  courseColl: any = [];
  courseid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  courseform = new FormGroup({
    courseid: new FormControl(0),
    coursename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Course";


  @Input() coursename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.courseid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.courseform.reset();
      this.fnInitializeCourse();

      if (this.courseid > 0) {
        this.fngetCourse();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.courseid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeCourse() {
    this.courseform.setValue({

      courseid: 0,
      coursename: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetCourse() {
   
    var data = {
      'courseid': this.courseid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getCourse(data)
      .subscribe(
        (res) => {
          this.courseColl = res.json().result;
          var editdata = this.courseColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if(this.saveloading){
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.courseform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'courseid': this.courseid,
          'coursename': this.courseform.get('coursename').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.courseform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckCourse(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.courseform.get('courseid').value > 0) {
                //Update Department
                this.fnSetCourse(data);
              }
              else {
                //Insert Department
                this.fnInsertCourse(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false

                this.courseform.controls['coursename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertCourse(data) {

    this.appService.fnInsertCourse(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The new Course has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.courseid);

          this.emitData.emit(this.courseid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetCourse(data) {

    this.appService.fnSetCourse(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The Course has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.courseid, data.coursename);

          this.emitData.emit(this.courseid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.courseform.setValue({

      courseid: deptBO.courseid,
      coursename: deptBO.coursename,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
